import Head from 'next/head'
import Link from 'next/link'
import jsonApiClient from '../../../utils/jsonApiClient'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import TutorProfileSummaryPanel from '../../../components/tutorProfile/SummaryPanel'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons'
import TutorRequestRequestContainer from '../../../components/tutorRequest/RequestContainer'

export async function getStaticProps({params}) {
  const jsonApi = jsonApiClient()
  const { data: tutorProfile } = await jsonApi.find('tutor-profile', params.slug)

  return {
    props: {
      tutorProfile
    },
    revalidate: 60
  }
}

export async function getStaticPaths() {
  const jsonApi = jsonApiClient()
  const { data } = await jsonApi.findAll('tutor-profile', {
    page: {
      size: 1000
    }
  })

  return {
    paths: data.map(tutorProfile => (
      {
        params: {
          slug: tutorProfile.slug
        }
      }
    )),
    fallback: 'blocking'
  }
}

export default function TutorsProfileReviews({tutorProfile}) {
  return <>
    <Head>
      <title>Send Message | {tutorProfile.firstNameAndLastInitial} | Tutorspot</title>
    </Head>
    <Container className="pt-3 mb-5">
      <h1 className="mb-3">
        Send a Message to {tutorProfile.firstNameAndLastInitial}
      </h1>
      <Row>
        <Col xs={12} md={8}>
          <div className="mb-3">
            <Link href={`/tutors/${tutorProfile.slug}`} passHref>
              <FontAwesomeIcon icon={faArrowLeft} className="me-1" />
              Back to Profile
            </Link>
          </div>

          <Card>
            <Card.Body>
              <TutorRequestRequestContainer tutorProfile={tutorProfile} />
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={4} className="d-none d-md-block">
          <Card>
            <Card.Body>
              <TutorProfileSummaryPanel tutorProfile={tutorProfile} />
            </Card.Body>
          </Card>
        </Col></Row>
    </Container>
  </>
}
